import React from "react";

const dot = (color) => ({ display: "inline-block", width: 8, height: 8, borderRadius: 999, background: color });

export function FreshnessIndicator({ lastUpdatedAt, ageSeconds, freshness }) {
  let age = ageSeconds;
  if (age == null && lastUpdatedAt) age = Math.max(0, (Date.now() - new Date(lastUpdatedAt).getTime()) / 1000);
  const level = freshness || (age == null ? "stale" : age < 60 ? "current" : age < 600 ? "delayed" : "stale");
  const color = level === "current" ? "var(--brand-lime)"
    : level === "delayed" ? "var(--status-hold)" : "var(--status-maintenance)";
  const label = level === "current"
    ? "LIVE"
    : level === "delayed"
      ? `DELAYED · ${Math.round((age || 0) / 60)} min ago`
      : age
        ? `STALE · ${Math.round(age / 60)} min ago`
        : "STALE";
  return (
    <span className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-widest font-medium"
      data-testid={`freshness-${level}`}
      style={{ color }}
    >
      <span style={dot(color)} />
      {label}
    </span>
  );
}

// Minimal SVG US mainland with a lat/lng pin.
// Uses a linear projection over CONUS bounds — good enough for a demo pin.
const CONUS = { latMin: 24, latMax: 50, lngMin: -125, lngMax: -66 };

export function StaticUSMap({ lat, lng, label, pinColor = "var(--brand-lime)" }) {
  const inBounds = lat != null && lng != null
    && lat >= CONUS.latMin && lat <= CONUS.latMax
    && lng >= CONUS.lngMin && lng <= CONUS.lngMax;
  const x = inBounds ? ((lng - CONUS.lngMin) / (CONUS.lngMax - CONUS.lngMin)) * 800 : null;
  const y = inBounds ? (1 - (lat - CONUS.latMin) / (CONUS.latMax - CONUS.latMin)) * 460 : null;

  return (
    <div data-testid="static-us-map" className="relative w-full">
      <svg viewBox="0 0 800 460" className="w-full h-auto block"
        role="img" aria-label="US map">
        <rect x="0" y="0" width="800" height="460" fill="var(--bg-inset)" />
        {/* Simplified CONUS silhouette (rough polygon) */}
        <path
          d="M60,340 L90,300 L120,290 L150,260 L200,240 L250,240 L300,220 L340,210 L380,200 L420,180 L460,180 L500,160 L540,150 L580,150 L620,160 L640,170 L660,190 L680,220 L700,240 L720,260 L740,300 L730,330 L700,360 L660,380 L620,390 L570,400 L520,400 L480,395 L440,400 L400,410 L360,415 L320,410 L280,405 L240,400 L200,395 L160,385 L120,370 L90,360 Z"
          fill="var(--bg-surface)" stroke="var(--fg-muted)" strokeWidth="1.5" opacity="0.85"
        />
        {inBounds ? (
          <>
            <circle cx={x} cy={y} r="12" fill={pinColor} opacity="0.25" />
            <circle cx={x} cy={y} r="5" fill={pinColor} stroke="white" strokeWidth="1.5" />
          </>
        ) : null}
      </svg>
      <div className="text-[12.5px] mt-2" style={{ color: "var(--fg-secondary)" }}>
        {inBounds ? (label || "Location") : `Location outside map bounds (${lat}, ${lng})`}
      </div>
    </div>
  );
}
